/*
 * Jira Ticket:
 * Created Date: Thu, 27th Jan 2022, 21:27:08
 * Author: Mark Wilkinson
 * Email: mark.wilkinson@thedistance.co.uk
 * Copyright (c) 2022 The Distance
 */

import React from 'react';

const PersistentOrganisationContext = React.createContext(null);

export function PersistentOrganisationProvider({ children }) {
  const [persistentOrganisation, setPersistentOrganisation] = React.useState(
    {}
  );

  const onSelectPersistentOrganisation = event => {
    const id = event.target.value;
    if (id === '') {
      setPersistentOrganisation({});
    } else {
      setPersistentOrganisation({ id });
    }
  };

  return (
    <PersistentOrganisationContext.Provider
      value={{
        persistentOrganisation,
        setPersistentOrganisation,
        onSelectPersistentOrganisation,
      }}
    >
      {children}
    </PersistentOrganisationContext.Provider>
  );
}

export function usePersistentOrganisation() {
  const context = React.useContext(PersistentOrganisationContext);
  if (context === undefined || context === null) {
    throw new Error(
      '`usePersistentOrganisation` hook must be used within a `LoadingProvider` component'
    );
  }
  return context;
}
